<div class="branch-selector">
  <div
    class="d-flex align-items-center switcher-context"
    (click)="toggleBranchSelector($event)"
  >
    <div [ngClass]="{ 'd-flex px-2 py-1 config': 1 }">
      <app-smooth-width
        [trigger]="selectedBranch"
        [ngClass]="{ 'config-item': 1, 'disable-switcher': fetchingBranches }"
      >
        <ng-container *ngIf="selectedBranch">
          <div class="config-item">
            <nb-icon pack="fci" icon="branch"></nb-icon>
            <span class="item-name">
              <ng-container *ngIf="!fetchingBranches">
                {{ selectedBranch }}
              </ng-container>
              <div
                *ngIf="fetchingBranches"
                [nbSpinner]="true"
                class="branch-loader"
              ></div>
            </span>
          </div>
        </ng-container>
      </app-smooth-width>
    </div>
    <div
      [ngClass]="{
        branchSwitcherIcon: 1,
        'disable-switcher': fetchingBranches
      }"
      (click)="toggleBranchSelector($event)"
    >
      <button nbButton size="small" ghost *ngIf="!branchSelectorOpen">
        <nb-icon icon="arrow-down-outline"></nb-icon>
      </button>
      <button nbButton ghost size="small" *ngIf="branchSelectorOpen">
        <nb-icon icon="arrow-up-outline"></nb-icon>
      </button>
    </div>
  </div>
</div>

<ng-container #contextSwitcher *ngIf="branchSelectorOpen">
  <div id="contextSwitcherWrapper">
    <nb-card class="mb-0" style="height: 28rem">
      <nb-card-body *ngIf="!allBranchesBackup?.length && !allBranches?.length">
        <app-message
          primaryMsg="Error"
          [secondaryMsg]="'No branches found for this blueprint'"
          [showBtn]="false"
          status="error"
          [changeBackground]="false"
        ></app-message>
      </nb-card-body>
      <nb-card-body
        class="d-flex"
        *ngIf="allBranches?.length || allBranchesBackup?.length"
      >
        <div class="selector" *ngIf="selectedBranch">
          <input
            [(ngModel)]="searchedBranch"
            (ngModelChange)="onBranchSearchInput(searchedBranch)"
            nbInput
            type="text"
            fullWidth
            placeholder="Search Branch"
            class="m-3"
            style="margin-bottom: 0 !important; width: auto"
          />

          <ng-container #newBranchButton>
            <button
              nbButton
              outline
              status="primary"
              class="m-3 p-2"
              (click)="openNewBranchForm()"
            >
              <nb-icon
                icon="plus-outline"
                class="d-flex align-items-center"
              ></nb-icon>
              <span style="font-size: small">Add Branch</span>
            </button>
          </ng-container>

          <div class="d-flex flex-column" class="all-options-wrapper">
            <div
              *ngIf="!allBranches?.length && allBranchesBackup?.length"
              class="d-flex justify-content-start"
              style="font-weight: 400"
            >
              No branches found
            </div>
            <ng-container *ngFor="let branch of allBranches">
              <div
                (click)="onBranchChange(branch)"
                [ngClass]="{
                  configOption: 1,
                  activeItem: branch === nextSelectedBranch,
                  'd-flex': 1
                }"
              >
                {{ branch }}
                <nb-badge
                  *ngIf="branch === defaultBranch"
                  text="Default"
                  status="success"
                  position="null"
                  class="ml-2 position-relative"
                ></nb-badge>
              </div>
            </ng-container>
          </div>
        </div>
      </nb-card-body>
      <nb-card-footer
        *ngIf="allBranches?.length"
        class="d-flex justify-content-end pt-0"
      >
        <button
          nbButton
          size="small"
          class="mr-3"
          (click)="branchSelectorOpen = false"
        >
          Cancel
        </button>
        <button
          nbButton
          size="small"
          status="primary"
          (click)="applyBranchChange()"
        >
          Apply
        </button>
      </nb-card-footer>
    </nb-card>
  </div>
</ng-container>

<ng-template #addNewBranchDialog let-data let-ref="dialogRef">
  <nb-card style="width: 40vw">
    <nb-card-header class="d-flex justify-content-between">
      <h6>Add New Branch</h6>
      <nb-icon
        icon="close-outline"
        class="cursor-pointer"
        (click)="ref.close()"
      ></nb-icon>
    </nb-card-header>
    <nb-card-body>
      <div class="formWrapper">
        <form [formGroup]="branchForm">
          <app-reactive-form-field
            label="Branch Name"
            [required]="true"
            labelSize="4"
            fieldId="branchName"
            fieldName="branchName"
            inputSize="8"
            placeholder="Branch Name"
            missingMsg="Branch name is required!"
            [customFormControl]="branchName"
          ></app-reactive-form-field>
        </form>
      </div>
    </nb-card-body>

    <nb-card-footer class="pt-0">
      <app-rbac-button
        label="Add"
        status="primary"
        size="small"
        [loading]="addingNewBranch"
        action="STACK_WRITE"
        (onClick)="createNewBranch(ref)"
        class="cc-margin-right"
        [disabled]="branchForm?.invalid || addingNewBranch"
        dataAttrActionId="branch-manager-add-new-branch"
      ></app-rbac-button>

      <button
        nbButton
        size="small"
        (click)="ref.close()"
        class="cc-margin-right"
        [disabled]=""
      >
        Cancel
      </button>
    </nb-card-footer>
  </nb-card>
</ng-template>
